import { render, staticRenderFns } from "./LoanWizardIntro.vue?vue&type=template&id=52b79216&"
import script from "./LoanWizardIntro.vue?vue&type=script&lang=js&"
export * from "./LoanWizardIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports